export default "__VITE_ASSET__b2b735b5__"